// src/pages/dashboard/components/GlucoseCard.jsx
import { useMemo } from "react";
import { startOfMonth } from "date-fns";
import { useGlucoseMonth } from "../../../../hooks/useHealthMetrics";
import CircularProgress from "../../../../components/charts/CircularProgress";

export default function GlucoseCard() {
    const month = startOfMonth(new Date());
    const { data: glucoseMonth = [] } = useGlucoseMonth(month);

    const [latest1] = useMemo(() => {
        const sorted = [...glucoseMonth].sort(
            (a, b) => new Date(b.dt) - new Date(a.dt)
        );
        return [sorted[0] ?? null];
    }, [glucoseMonth]);

    const renderLabel = (reading) => (
        <div className="flex flex-col items-center leading-tight">
            <span className="text-2xl md:text-3xl">
                {reading ? reading.fasting : ""}
            </span>
        </div>
    );

    return (
        <div
            className="
                px-7 py-4 md:px-7 md:py-5
                bg-white rounded-2xl
                flex items-center justify-center
            "
        >
            <div className="flex flex-col items-center space-y-2">
                <p className="text-base md:text-lg font-bold">공복 혈당</p>

                <CircularProgress
                    variant="ring"
                    color="#E9D045"
                    label={renderLabel(latest1)}
                    className="w-[120px] h-[120px] md:w-[120px] md:h-[120px]"
                    type="혈당"
                />
            </div>
        </div>
    );
}